import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import CatalogueView from "@/components/Catalogue/CatalogueView.vue";
import ProductPromoCode from "@/components/PromoCode/product_promo_code.vue";
import { get_token, get_user_details } from "@/router";
import { my_shop_helpers } from "./my_shop_helper";
import { format_price, view_profile_product } from "@/views/Marketplace/marketplace_helpers";
import {
    add_attribute_value,
    group_attributes,
    remove_attribute
} from "@/views/BusinessProfileView/business_profile_helper";

function create_item_form() {
    return {
        name: "",
        price: null,
        description: "",
        service_type: null,
        service_type_id: null,
        service_location: "",
        attributes: {}
    };
}

function create_update_item_form() {
    return {
        product_id: "",
        name: "",
        price: "",
        description: "",
        subcategory_id: "",
        attributes: {},
        service_type_id: "",
        service_type: "",
        location: "",
    };
}

export default {
    name: "MyShopView",
    components: {
        HomeNavBar,
        CatalogueView,
        ProductPromoCode,
    },
    watch: {
        service_types: {
            handler(new_types) {
                if (new_types && new_types.length > 0 && this.modalType === "service" && !this.item_form.service_type_id) {
                    const drop_in_type = new_types.find((type) => String(type.name || "").toLowerCase() === "drop_in");
                    if (drop_in_type) {
                        this.item_form.service_type_id = drop_in_type.id;
                    }
                }
            },
            deep: true,
            immediate: true,
        },
    },
    data() {
        return ({
            loading: true,
            errors: {},
            user_details: get_user_details() || {},
            base_profile_id: null,
            active_home_profile: null,
            shop_profile: null,
            active_tab: "products",
            profile_products: [],
            catalogue_products: [],
            catalogue_services: [],
            product_types: [],
            orders: [],
            requests: [],
            isLoading: false,
            isEditing: false,
            is_deleting: false,
            isDragging: false,
            modal_product: "",
            upload_files: [],
            previews: [],
            active_modal_image_index: 0,
            categories: [],
            subcategories: [],
            selected_category: "",
            selected_subcategory: "",
            service_types: [],
            attributeTypes: [],
            new_attribute_value: {},
            modalType: "product",
            item_form: create_item_form(),
            update_item_form: create_update_item_form(),
        });
    },
    computed: {
        is_dropin_selected() {
            const selected_type = this.service_types.find((type) => type.id === this.item_form.service_type_id);
            return selected_type && selected_type.name === "drop_in";
        },
        catalogue_items() {
            return this.active_tab === "services" ? this.catalogue_services : this.catalogue_products;
        },
        pending_orders() {
            return this.orders || [];
        },
        pending_requests() {
            return this.requests || [];
        },
        catalogueTab() {
            return this.active_tab;
        },
        view_model() {
            return this;
        },
        isDeleting: {
            get() {
                return this.is_deleting;
            },
            set(value) {
                this.is_deleting = value;
            },
        },
        shop_title() {
            return this.active_home_profile?.profile_name
                || this.active_home_profile?.company_name
                || this.active_home_profile?.name
                || this.shop_profile?.profile_name
                || this.shop_profile?.company_name
                || this.shop_profile?.name
                || "My Shop";
        },
    },
    mounted() {
        this.loading = true;
        this.get_active_base_products()
            .then(() => this.get_active_base_services())
            .then(() => Promise.allSettled([
                this.fetch_product_types(),
                this.get_attribute_types(),
                this.get_orders(),
                this.get_requests(),
            ]))
            .catch((error) => {
                this.errors.page_load = error?.message || "Failed to load shop data.";
            })
            .finally(() => {
                this.loading = false;
                this.$nextTick(() => {
                    this.initialize_add_item_location_autocomplete();
                });
            });
    },
    methods: {
        ...my_shop_helpers,
        getToken() {
            return get_token();
        },
        sync_catalogue_items(items = []) {
            this.profile_products = items;
            this.catalogue_products = items.filter(
                (product) => product.product_type?.name !== "service" || product.product_type === null
            );
            this.catalogue_services = items.filter(
                (product) => product.product_type?.name === "service"
            );
        },
        set_active_home_profile(profile) {
            this.active_home_profile = profile || null;

            if (profile?.id && !this.base_profile_id) {
                this.base_profile_id = profile.id;
            }

            if (profile) {
                this.shop_profile = profile;
            }
        },
        validate_service_form() {
            if (this.modalType !== "service") return false;

            let has_error = false;
            if (!this.item_form.service_type_id) {
                this.errors.service_type = "Please select a service type";
                has_error = true;
            }
            if (this.is_dropin_selected && !this.item_form.service_location?.trim()) {
                this.errors.service_location = "Location is required for drop-in services";
                has_error = true;
            }

            return has_error;
        },
        fetch_product_types() {
            return new Promise((resolve, reject) => {
                $.ajax({
                    type: "GET",
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_product_types/`,
                    headers: {
                        Authorization: `Token ${this.getToken()}`,
                    },
                    success: (response) => {
                        if (response.status === "success") {
                            this.product_types = response.data || [];
                            this.service_types = response.service_data || [];
                            this.set_default_service_type();
                            resolve(response.data);
                            return;
                        }
                        reject(new Error(response.message || "Failed to load product types."));
                    },
                    error: (xhr) => {
                        reject(new Error(xhr.responseJSON?.message || "Failed to load product types."));
                    }
                });
            });
        },
        get_attribute_types() {
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_attribute_types/`,
                    type: "GET",
                    headers: {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    },
                    success: (response) => {
                        if (response.status === "success") {
                            this.attributeTypes = response.data || [];
                            resolve(response.data);
                            return;
                        }
                        reject(new Error(response.message || "Failed to load attribute types."));
                    },
                    error: (xhr) => {
                        reject(new Error(xhr.responseJSON?.message || "Failed to load attribute types."));
                    }
                });
            });
        },
        go_back() {
            this.$router.back();
        },
        view_product_details(product) {
            view_profile_product(this.$router, product);
        },
        initialize_add_item_location_autocomplete() {
            const input_element = this.$refs.addItemLocationInput;
            if (!input_element) return;

            if (typeof window.google === "undefined" || !window.google.maps || !window.google.maps.places) {
                setTimeout(() => {
                    this.initialize_add_item_location_autocomplete();
                }, 500);
                return;
            }

            this.get_autocomplete_location(input_element, (address) => {
                this.item_form.service_location = address;
                this.errors.service_location = null;
            });
        },
        get_autocomplete_location(inputElement, onAddressSelected) {
            if (!inputElement) return;
            if (typeof window.google === "undefined" || !window.google.maps || !window.google.maps.places) {
                return;
            }

            const autocomplete = new window.google.maps.places.Autocomplete(inputElement, {
                types: ["address"],
            });

            autocomplete.addListener("place_changed", () => {
                const place = autocomplete.getPlace();
                if (place && place.formatted_address) {
                    onAddressSelected(place.formatted_address);
                }
            });
        },
        set_modal_type(type) {
            this.modalType = type;
            this.selected_category = "";
            this.selected_subcategory = "";
            this.item_form.attributes = {};
            this.item_form.service_location = "";
            this.item_form.service_type_id = null;
            this.set_default_service_type();
            this.fetch_categories();
        },
        set_default_service_type() {
            if (this.modalType !== "service") return;
            if (this.item_form.service_type_id) return;

            const drop_in_type = this.service_types.find(
                (type) => String(type.name || "").toLowerCase() === "drop_in"
            );

            if (drop_in_type) {
                this.item_form.service_type_id = drop_in_type.id;
            }
        },
        validate_item_form() {
            this.errors = {};
            let has_error = false;

            if (!this.item_form.name || !this.item_form.name.trim()) {
                this.errors.name = "Product name is required";
                has_error = true;
            }
            if (this.item_form.price === "" || this.item_form.price === null) {
                this.errors.price = "Product price is required";
                has_error = true;
            } else if (Number(this.item_form.price) <= 0) {
                this.errors.price = "Price must be greater than 0";
                has_error = true;
            }

            has_error = this.validate_service_form() || has_error;

            return has_error;
        },
        reset_product_form() {
            this.errors = {};
            this.item_form = create_item_form();
            this.update_item_form = create_update_item_form();
            this.isEditing = false;
            this.selected_category = "";
            this.selected_subcategory = "";
            this.subcategories = [];
            this.upload_files = [];
            this.previews = [];
            this.isLoading = false;
            this.new_attribute_value = {};
            this.active_modal_image_index = 0;
        },
        cancel_edit() {
            this.isEditing = false;
            this.reset_product_form();
        },
        close_add_item_modal() {
            this.reset_product_form();
            $("#addItemModal").modal("hide");
        },
        close_manage_modal() {
            this.reset_product_form();
            $("#manageProductModal").modal("hide");
        },
        open_product_promo_code_manager(product) {
            if (!product?.id) return;

            this.modal_product = product;
            $("#manageProductModal").modal("hide");

            this.$nextTick(() => {
                this.$refs.productPromoCodeRef?.open_product_promo_code_manager_modal?.(product);
            });
        },
        open_catalogue_promo_code_manager() {
            const products = (this.catalogue_products || []).filter(
                (product) => product?.id && String(product?.product_type?.name || "").toLowerCase() !== "service"
            );
            if (!products.length) return;

            this.$nextTick(() => {
                this.$refs.productPromoCodeRef?.open_catalogue_promo_code_manager_modal?.({
                    products,
                    base_profile_id: this.base_profile_id,
                });
            });
        },
        update_parent_product_promos(payload) {
            const product_id = String(payload?.product_id || this.modal_product?.id || "");
            const promo = payload?.promo;
            if (!product_id || !promo) return;

            const product = (this.profile_products || []).find(
                (item) => String(item.id) === product_id
            ) || this.modal_product;
            if (!product) return;

            const currentPromos = product.product_promo_codes || product.promo_codes || [];
            const promoIndex = currentPromos.findIndex(
                (item) => String(item.id) === String(promo.id)
            );

            if (promoIndex === -1) {
                currentPromos.unshift(promo);
            } else {
                currentPromos.splice(promoIndex, 1, promo);
            }

            product.product_promo_codes = currentPromos;

            if (String(this.modal_product?.id) === product_id) {
                this.modal_product = product;
            }
        },
        handle_parent_product_promo_deletion(payload) {
            const product_id = String(payload?.product_id || this.modal_product?.id || "");
            const promo_id = String(payload?.promo_id || "");
            if (!product_id || !promo_id) return;

            const product = (this.profile_products || []).find(
                (item) => String(item.id) === product_id
            ) || this.modal_product;
            if (!product) return;

            const currentPromos = product.product_promo_codes || product.promo_codes || [];
            product.product_promo_codes = currentPromos.filter(
                (promo) => String(promo.id) !== promo_id
            );

            if (String(this.modal_product?.id) === product_id) {
                this.modal_product = product;
            }
        },
        handleImagesUpload(event) {
            const files = Array.from(event.target.files || []);
            if (!files.length) return;

            files.forEach((file) => {
                this.upload_files.push(file);
                if (file.type.startsWith("image/")) {
                    const reader = new FileReader();
                    reader.onload = (load_event) => {
                        this.previews.push({
                            type: "image",
                            src: load_event.target.result,
                            name: file.name,
                            file,
                        });
                    };
                    reader.readAsDataURL(file);
                    return;
                }

                const url = URL.createObjectURL(file);
                this.previews.push({
                    type: "video",
                    src: url,
                    name: file.name,
                    file,
                });
            });

            event.target.value = "";
        },
        handle_drop(event) {
            this.isDragging = false;
            const files = event.dataTransfer.files;
            if (files.length > 0) {
                this.handleImagesUpload({ target: { files } });
            }
        },
        remove_file(index) {
            const file = Reflect.get(this.previews, index);
            if (file.id) {
                // Existing image: mark for deletion
                file._delete = true;
            } else {
                // Newly uploaded file: remove from upload_files and previews
                const fileIndex = this.upload_files.indexOf(file.file);
                if (fileIndex > -1) this.upload_files.splice(fileIndex, 1);
                this.previews.splice(index, 1);
            }
            },
        prev_modal_image() {
            const total = this.modal_product?.images?.length || 0;
            if (!total) return;
            this.active_modal_image_index = (this.active_modal_image_index - 1 + total) % total;
        },
        next_modal_image() {
            const total = this.modal_product?.images?.length || 0;
            if (!total) return;
            this.active_modal_image_index = (this.active_modal_image_index + 1) % total;
        },
        add_attribute_value(type) {
            const target_form = this.isEditing ? this.update_item_form : this.item_form;
            add_attribute_value(target_form, this.new_attribute_value, type);
        },
        handle_attribute_input_keydown(event, type) {
            if (!event || !type) return;
            if (event.key === "Enter" || event.key === ",") {
                event.preventDefault();
                this.add_attribute_value(type);
            }
        },
        group_attributes(attributes) {
            return group_attributes(attributes);
        },
        remove_attribute(item_form, type_name, index) {
            return remove_attribute(item_form, type_name, index);
        },
        display_price(product) {
            return product?.final_price ?? product?.price ?? 0;
        },
        format_price(value) {
            return format_price(value);
        },
        format_date(datestr) {
            const date = new Date(datestr);
            const day = date.getDate();
            const suffix = ((d) => {
                if (d > 3 && d < 21) return "th";
                switch (d % 10) {
                    case 1: return "st";
                    case 2: return "nd";
                    case 3: return "rd";
                    default: return "th";
                }
            })(day);

            const weekday = date.toLocaleDateString("en-US", { weekday: "long" });
            const month = date.toLocaleDateString("en-US", { month: "long" });
            const year = date.getFullYear();

            return `${weekday}, ${month} ${day}${suffix}, ${year}`;
        },
        view_all_orders() {
            this.$router.push({ name: "orders", query: { base_profile_id: this.base_profile_id } });
        },
    },
};
